import { render, staticRenderFns } from "./MatchNoneAndGSRPReferral.vue?vue&type=template&id=226c85c0&"
import script from "./MatchNoneAndGSRPReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchNoneAndGSRPReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports